import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 p-4 sm:p-6 lg:p-8"
}
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex flex-wrap gap-3" }
const _hoisted_4 = { class: "space-y-6 rounded-lg bg-white p-4 shadow sm:p-6" }
const _hoisted_5 = {
  key: 0,
  class: "px-4 py-2"
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiListSearch = _resolveComponent("UiListSearch")!
  const _component_UiSettingsRow = _resolveComponent("UiSettingsRow")!
  const _component_UiSettingsSection = _resolveComponent("UiSettingsSection")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return ($setup.waba && $setup.policy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'ListWhatsAppMeta' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('whatsappMeta.detail.back')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_UiButton, {
              variant: "white",
              "text-variant": "primary",
              disabled: $setup.busy || Boolean($setup.waba.disconnectedAt),
              onClick: $setup.synchronize
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t('whatsappMeta.detail.synchronizeNumbers')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"]),
            ($setup.shouldPrepareIntegration)
              ? (_openBlock(), _createBlock(_component_UiButton, {
                  key: 0,
                  variant: "primary",
                  "text-variant": "white",
                  disabled: $setup.busy,
                  onClick: $setup.prepareIntegration
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('whatsappMeta.detail.prepareIntegration')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["WhatsAppMetaHeader"], {
            title: $setup.waba.displayName || $setup.waba.wabaId,
            subtitle: `WABA ${$setup.waba.wabaId}`,
            "status-label": $setup.status ? $setup.t(`whatsappMeta.list.status.${$setup.status}`) : '',
            "status-variant": $setup.status ? $setup.WhatsAppWabaStatusColorMap[$setup.status] : undefined,
            summary: $setup.t('whatsappMeta.detail.numbersInWaba', $setup.waba.phoneNumbers.length)
          }, null, 8 /* PROPS */, ["title", "subtitle", "status-label", "status-variant", "summary"]),
          _createVNode($setup["CompanyPhoneQuotaSummary"], {
            used: $setup.policy.used,
            limit: $setup.policy.limit,
            full: $setup.policy.full
          }, null, 8 /* PROPS */, ["used", "limit", "full"]),
          _createVNode(_component_UiSettingsSection, {
            title: $setup.t('whatsappMeta.detail.numbers'),
            footer: $setup.t('whatsappMeta.detail.numbersFooter')
          }, {
            "header-action": _withCtx(() => [
              _createVNode(_component_UiBadge, {
                variant: "gray-100",
                "text-variant": "gray-700",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('whatsappMeta.detail.numberCount', $setup.waba.phoneNumbers.length)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            default: _withCtx(() => [
              ($setup.hasMoreThanTenPhones)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_UiListSearch, {
                      modelValue: $setup.search,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.search) = $event)),
                      placeholder: $setup.t('whatsappMeta.detail.searchNumber'),
                      class: "flex-1"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.waba.phoneNumbers.length === 0)
                ? (_openBlock(), _createBlock(_component_UiSettingsRow, {
                    key: 1,
                    title: $setup.t('whatsappMeta.detail.noNumbersInWaba'),
                    description: $setup.t('whatsappMeta.detail.noNumbersGuidance')
                  }, null, 8 /* PROPS */, ["title", "description"]))
                : ($setup.filteredPhones.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.pagePhones, (phone) => {
                      return (_openBlock(), _createBlock($setup["WhatsAppMetaPhoneNumberListItem"], {
                        key: phone.phoneNumberId,
                        phone: phone,
                        "policy-phone": $setup.phonePolicy(phone),
                        "can-enable": $setup.isQuotaAvailable,
                        onActivate: 
                            (id) =>
                                ($setup.phoneToActivate =
                                    $setup.waba?.phoneNumbers.find(
                                        (phone) => phone.phoneNumberId === id,
                                    ) || null)
                        ,
                        onApproval: $setup.requestEnabled
                      }, null, 8 /* PROPS */, ["phone", "policy-phone", "can-enable", "onActivate"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : (_openBlock(), _createBlock(_component_UiSettingsRow, {
                      key: 3,
                      title: $setup.t('whatsappMeta.detail.noNumbersFound')
                    }, null, 8 /* PROPS */, ["title"]))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title", "footer"]),
          ($setup.hasMoreThanTenPhones && $setup.filteredPhones.length)
            ? (_openBlock(), _createBlock(_component_UiPagination, {
                key: 0,
                modelValue: $setup.phonePage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.phonePage) = $event)),
                count: $setup.filteredPhones.length,
                "per-page": $setup.perPage
              }, null, 8 /* PROPS */, ["modelValue", "count"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_UiSettingsSection, {
            title: $setup.t('whatsappMeta.detail.links')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.externalLinks, (link) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: link.href,
                  class: "flex min-h-[52px] items-center justify-between p-4 text-sm font-medium text-gray-900 hover:bg-gray-50/70",
                  href: link.href,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createTextVNode(_toDisplayString(link.label) + " ", 1 /* TEXT */),
                  _createVNode($setup["ExternalLinkIcon"], {
                    class: "h-4 w-4 text-gray-400",
                    "aria-hidden": "true"
                  })
                ], 8 /* PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_UiSettingsSection, {
            title: $setup.t('whatsappMeta.detail.connection'),
            variant: "danger"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UiSettingsRow, {
                title: $setup.t('whatsappMeta.detail.disconnectWaba'),
                description: $setup.t('whatsappMeta.detail.disconnectFootnote')
              }, {
                action: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "danger",
                    "text-variant": "white",
                    disabled: $setup.busy || Boolean($setup.waba.disconnectedAt),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isDisconnectOpen = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('whatsappMeta.detail.disconnectWaba')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title", "description"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ]),
        _createVNode($setup["WhatsAppMetaPhoneActivationDialog"], {
          phone: $setup.phoneToActivate,
          "is-submitting": $setup.busy,
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.phoneToActivate = null)),
          onConfirm: $setup.activate
        }, null, 8 /* PROPS */, ["phone", "is-submitting"]),
        _createVNode($setup["WhatsAppMetaConfirmDialog"], {
          open: $setup.phoneToDisable !== null,
          title: $setup.t('whatsappMeta.disableDialog.title'),
          description: 
                $setup.t('whatsappMeta.disableDialog.description', {
                    phone: $setup.phoneToDisable?.displayPhoneNumber || '',
                })
            ,
          "confirm-label": $setup.t('whatsappMeta.disableDialog.confirm'),
          "is-submitting": $setup.busy,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.phoneToDisable = null)),
          onConfirm: $setup.confirmDisable
        }, null, 8 /* PROPS */, ["open", "title", "description", "confirm-label", "is-submitting"]),
        _createVNode($setup["WhatsAppMetaConfirmDialog"], {
          open: $setup.isDisconnectOpen,
          title: $setup.t('whatsappMeta.disconnectDialog.title'),
          description: 
                $setup.t('whatsappMeta.disconnectDialog.description', {
                    waba: $setup.waba.displayName || $setup.waba.wabaId,
                })
            ,
          "confirm-label": $setup.t('whatsappMeta.disconnectDialog.confirm'),
          "is-submitting": $setup.busy,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.isDisconnectOpen = false)),
          onConfirm: $setup.disconnect
        }, null, 8 /* PROPS */, ["open", "title", "description", "confirm-label", "is-submitting"])
      ]))
    : _createCommentVNode("v-if", true)
}